import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fadeInOnly } from '../../utils/animations';
 import beliefsImage from 'assets/beliefs.jpg'; // Placeholder
  import identityImage from 'assets/identity.jpg'; // Placeholder
  import historyImage from 'assets/history.jpg';   // Placeholder


// Styled components (basic structure, adapt as needed)
const AboutPageContainer = styled.div`
  width: 100%;
  padding: 2rem;
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: ${fadeInOnly} 0.5s ease-out forwards;
`;

const PageTitle = styled.h1`
  font-family: ${(props) => props.theme.fontFamilies.primary};
  font-size: ${(props) => props.theme.fontSizes.h1};
  color: ${(props) => props.theme.colors.primary};
  margin-bottom: 2rem;
  text-align: center;
`;

const Section = styled.section`
  width: 100%;
  max-width: 900px;
  margin-bottom: 3rem;
  padding: 2rem;
  background-color: ${(props) => props.theme.colors.surface};
  border-radius: ${(props) => props.theme.borderRadius};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-family: ${(props) => props.theme.fontFamilies.primary};
  font-size: ${(props) => props.theme.fontSizes.h2};
  color: ${(props) => props.theme.colors.primary};
  margin-bottom: 1rem;
  text-align: left;
`;

const Description = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.secondary};
  font-size: ${(props) => props.theme.fontSizes.body};
  line-height: ${(props) => props.theme.lineHeights.body};
  color: ${(props) => props.theme.colors.text};
  white-space: pre-wrap; /* To respect newlines in translations */
  margin-bottom: 1rem;
`;

const StyledImage = styled.img`
  width: 100%;
  max-width: 400px; /* Or adjust as needed */
  height: auto;
  border-radius: ${(props) => props.theme.borderRadius};
  margin: 1rem auto; /* Center image if it's smaller than container */
  display: block;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

interface AboutSectionProps {
  titleKey: string;
  descriptionKey: string;
  imageSrc?: string; // Optional image source
  imageAltKey?: string; // Optional image alt text key
}

const AboutSection: React.FC<AboutSectionProps> = ({ titleKey, descriptionKey, imageSrc, imageAltKey }) => {
  const { t } = useTranslation();
  return (
    <Section>
      <SectionTitle>{t(titleKey)}</SectionTitle>
      <Description>{t(descriptionKey)}</Description>
      {imageSrc && imageAltKey && (
        <StyledImage src={imageSrc} alt={t(imageAltKey)} />
      )}
    </Section>
  );
};

const AboutComponent: React.FC = () => {
  const { t, i18n } = useTranslation();

  console.log('Current language:',  i18n.language);

  // Example image paths - replace with your actual image paths or remove if not used
 
  return (
    <AboutPageContainer>
      <PageTitle>{t('header.about')}</PageTitle>

      <AboutSection
        titleKey="about.beliefsTitle"
        descriptionKey="about.beliefsDescription"
        imageSrc={beliefsImage} // Add your image path
        imageAltKey="about.beliefsImageAlt"
      />

      <AboutSection
        titleKey="about.identityTitle"
        descriptionKey="about.identityDescription"
        imageSrc={identityImage} // Add your image path
        imageAltKey="about.identityImageAlt"
      />

      <AboutSection
        titleKey="about.historyTitle"
        descriptionKey="about.historyDescription"
        imageSrc={historyImage} // Add your image path
        imageAltKey="about.historyImageAlt"
      />
    </AboutPageContainer>
  );
};

export default React.memo(AboutComponent);